<template>
  <div class="ace-feed">
    <Steps
      class="ace-feed__steps"
      :steps="steps"
      :currentStep="currentStep"
    />
    <Step1
      v-if="currentStep === 1"
      :dietTypes="dietTypes"
      @setDietType="setDietType"
    />
    <Step2
      v-if="currentStep === 2"
      :dietType="dietTypeData"
      :ingredients="dietTypeIngredients"
      @setDietTitle="setDietTitle"
      @setDiet="setDiet"
      @nextStep="incrementStep"
    />
    <Step3
      v-if="currentStep === 3"
      :dietType="dietTypeData"
      :ingredients="dietTypeIngredients"
      :dietTitle="dietTitle"
      :diet="diet"
    />
  </div>
</template>

<script>
import steps from './_steps';
import dietTypes from './_dietTypes';
import ingredients from './_ingredients';

import Steps from '../Layout/Steps.vue';
import Step1 from './Step-1.vue';
import Step2 from './Step-2.vue';
import Step3 from './Step-3.vue';

import './images/monogastric.png';
import './images/monogastric@2x.png';
import './images/ruminant.png';
import './images/ruminant@2x.png';

export default {
  data() {
    return {
      steps,
      dietTypes,
      ingredients,
      currentStep: 1,
      dietType: '',
      dietTitle: 'User inputted diet',
      diet: [],
    };
  },
  methods: {
    setDietType(dietType) {
      this.dietType = dietType;

      this.incrementStep();
    },
    setDietTitle(value) {
      this.dietTitle = value || 'User inputted diet';
    },
    setDiet(value) {
      this.diet = value;
    },
    incrementStep() {
      window.scrollTo(0, 0);
      this.currentStep += 1;
    },
  },
  computed: {
    dietTypeIngredients() {
      return this.ingredients[this.dietType];
    },
    dietTypeData() {
      return this.dietTypes[this.dietType] || {};
    },
  },
  components: {
    Steps,
    Step1,
    Step2,
    Step3,
  },
};

</script>

<style scoped lang="scss">
  .ace-feed
  {
      display: flex;
      flex-direction: column;

      align-items: center;
  }

</style>
